<template>
  <div class="volunteer-availability">
    <availability-config-card />

    <ag-table :data-source-api="getAllAvailability" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" @emitExportToExcel="onExportToExcel" />

    <vs-popup title="أيام التوفر" :active.sync="datesPopupActive" button-close-hidden>
      <h4 class="mb-4">{{ selectedVolunteerName }}</h4>
      <ul>
        <li v-for="(date, index) in selectedDates" :key="index" class="mb-2">
          {{ utilities.formatDayName(date) }} - {{ date }}
        </li>
      </ul>
    </vs-popup>
  </div>
</template>

<script>
import utilities from "@/app/shared/utilities/index";
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AvailabilityConfigCard from '../components/AvailabilityConfigCard.vue';
import AvailabilityDatesCell from '../components/AvailabilityDatesCell.vue';
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';

const availabilityRepo = RepositoryFactory.get('availabilityRepository');

export default {
  name: "VolunteerAvailability",
  components: {
    AgTable,
    AvailabilityConfigCard,
    // eslint-disable-next-line vue/no-unused-components
    AvailabilityDatesCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      permissions: {
        add: 'volunteer_manage',
        edit: 'volunteer_manage',
        delete: 'volunteer_manage',
      },
      datesPopupActive: false,
      selectedDates: [],
      selectedVolunteerName: '',
      utilities,
    };
  },
  methods: {
    createColDefs() {
      return [
        {
          headerName: 'الاسم',
          field: 'volunteerName',
          width: 210,
          sortable: false,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'رقم الموبايل',
          field: 'phoneNumber',
          width: 210,
          sortable: false,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'رقم البطاقة',
          field: 'cardNumber',
          width: 210,
          sortable: false,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'المشرف',
          field: 'supervisorName',
          width: 210,
          sortable: false,
          filter: 'agTextColumnFilter',
          valueGetter: function getObject(params) {
            return params.data.supervisorName || '-';
          },
        },
        {
          headerName: 'المجموعة',
          field: 'groupName',
          width: 210,
          sortable: false,
          filter: 'agTextColumnFilter',
          valueGetter: function getObject(params) {
            return params.data.groupName || '-';
          },
        },
        {
          headerName: 'أيام التوفر',
          field: 'dates',
          width: 320,
          sortable: false,
          cellRendererFramework: AvailabilityDatesCell,
          cellRendererParams: {
            onShowMore: this.showDatesPopup,
          },
        },
        {
          headerName: 'تاريخ الإرسال',
          field: 'createdAt',
          width: 200,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.createdAt ? utilities.formatDate(params.data.createdAt, "yyyy-MM-DD") : '-';
          },
          filter: 'agDateColumnFilter',
        },
      ];
    },
    async getAllAvailability(query) {
      return await availabilityRepo.fetchAvailabilityDays(query);
    },
    async onExportToExcel() {
      await availabilityRepo.exportAvailabilityDays();
    },
    showDatesPopup(rowData) {
      this.selectedDates = Array.isArray(rowData.dates) ? rowData.dates : [];
      this.selectedVolunteerName = rowData.volunteerName;
      this.datesPopupActive = true;
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
